import styled, { keyframes } from 'styled-components';
import media from 'styled-media-query';
import { fadeIn } from 'react-animations';
import { AiOutlineLoading } from 'react-icons/ai';

import { pxToRem } from '../../functions';

import { colors, fonts } from '../../theme';

const rotation = keyframes`
 to {
    transform: rotate(1turn);
  }
`;

const bounceFadeInAnimation = keyframes`${fadeIn}`;

const imageBorderColors = {
  default: {
    outside: 'rgba(215, 216, 218, 0.2)',
    inside: 'rgba(215, 216, 218, 0.7)',
  },
  review: {
    outside: 'rgba(255, 203, 0, 0.19)',
    inside: 'rgba(255, 203, 0, 0.7)',
  },
  approved: {
    outside: 'rgba(135, 197, 0, 0.2)',
    inside: 'rgba(135, 197, 0, 0.7)',
  },
  disapproved: {
    outside: 'rgba(208, 79, 95, 0.2)',
    inside: 'rgba(208, 79, 95, 0.7)',
  },
};

export const Container = styled.div`
  display: grid;
  grid-template-rows: 40px 1fr;

  height: 100%;
  padding: ${pxToRem(20)} ${pxToRem(40)};

  background-color: rgba(255, 255, 255, 0.86);

  ${media.greaterThan('1900px')`
    grid-template-rows: 50px 1fr;
  `}
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Main = styled.section`
  height: 100%;

  border-radius: ${pxToRem(16)};

  overflow: hidden;

  > * {
    animation: 0.15s ${bounceFadeInAnimation};
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  width: 100%;
  height: 100%;
`;

export const ImageContainer = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  .image-wrapper {
    width: ${pxToRem(241)};
    height: ${pxToRem(241)};

    border: solid 11px
      ${({ photoSituation }) => imageBorderColors[photoSituation].outside};

    img {
      width: 100%;
      min-height: ${pxToRem(219)};

      border: solid 5px
        ${({ photoSituation }) => imageBorderColors[photoSituation].inside};
    }
  }

  p {
    margin-top: ${pxToRem(20)};

    ${fonts.size2};
    color: ${colors.black};
  }

  &::after {
    position: absolute;
    top: 10%;
    right: 0;

    width: ${pxToRem(1)};
    height: 85%;

    content: '';
    background-color: rgba(178, 178, 178, 0.5);
  }

  #crop-confirmed-buttons {
    display: flex;
    align-items: center;

    margin-top: 2.235%;

    button {
      padding: unset;

      & + button {
        margin-left: ${pxToRem(16)};
      }
    }
  }
`;

export const ImageCrop = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  .upload-button {
    display: flex;
    align-items: center;
    justify-content: center;

    width: ${pxToRem(130)};
    height: ${pxToRem(32)};
    border-radius: ${pxToRem(17)};

    ${fonts.size2};
    cursor: pointer;
    letter-spacing: -0.4px;
    color: ${colors.white};
    transition: all 0.3s ease;
    background-color: ${colors.blue};
    font-family: 'SFProText-Semibold', sans-serif;

    :hover {
      filter: brightness(1.05);
    }

    :active {
      filter: brightness(1.1);
    }

    input[type='file'] {
      display: none;
    }
  }

  .cropper-wrapper {
    position: relative;

    width: ${pxToRem(315)};
    height: ${pxToRem(252)};
  }

  .cropper-controls {
    display: flex;
    align-items: flex-end;

    margin-top: ${pxToRem(16)};

    width: ${pxToRem(315)};

    .slider-wrapper {
      flex: 4;

      margin-right: ${pxToRem(21)};

      label {
        ${fonts.size2};
        color: ${colors.black};
      }

      .ant-slider {
        margin-left: 0;
      }
    }

    button {
      flex: 1;

      margin-bottom: ${pxToRem(10)};
    }
  }
`;

export const CloseButton = styled.button`
  z-index: 1;
  position: absolute;
  top: ${pxToRem(-3)};
  right: ${pxToRem(5)};

  border: none;
  ${fonts.size7};
  cursor: pointer;

  filter: opacity(0.5);
  color: ${colors.white};
  transition: all 0.15s ease;
  background-color: transparent;

  :hover {
    filter: opacity(1);
  }
`;

export const CircleLoading = styled(AiOutlineLoading)`
  font-size: 30px;
  color: ${colors.lightGreen};
  animation: ${rotation} 1s infinite;
`;
